// src/libraries/UploadedLayoutManager.js

import { uuidv4 } from "../utils/uuid";

let uploadedCells = [];

const UploadedLayoutManager = {
  load(jsonArray) {
    uploadedCells = jsonArray.map(cell => ({
      name: cell.name,
      elements: (cell.elements || []).map(el => ({
        ...el,
        id: uuidv4
      })),
      instances: (cell.instances || []).map(inst => ({
        ...inst,
        id: uuidv4,
        scale: inst.scale || 1,
        rotation: inst.rotation || 0
      }))
    }));
    window.dispatchEvent(new Event("hierarchy-updated"));
  },

  getCells() {
    return uploadedCells;
  },

  getCellByName(name) {
    return uploadedCells.find(cell => cell.name === name);
  },

  reset() {
    uploadedCells = [];
  }
};

export default UploadedLayoutManager;
